import { Injectable } from '@angular/core';
@Injectable()
export class AppInternalSettings {

    public static settings =  {
        get DATA_API_ENDPOINT(){
            if (process.env.API_URL) {
                return process.env.API_URL;
            } else if (window["_dynamic_config"] && window["_dynamic_config"].apiUrl) {
                return window["_dynamic_config"].apiUrl;
            }
            if (process.env.NODE_ENV === 'stage' || process.env.NODE_ENV === 'stageprod') {
                return `https://${this.STAGE_PREFIX}.chickasaw.tv/v1`;
            }
                return `https://${this.PROD_PREFIX}.chickasaw.tv/v1`;
        },
        get METADATA_API_ENDPOINT(){
            if (process.env.API_URL) {
                return process.env.API_URL;
            } else if (window["_dynamic_config"] && window["_dynamic_config"].apiUrl) {
                return window["_dynamic_config"].apiUrl;
            }
            if (process.env.NODE_ENV === 'stage' || process.env.NODE_ENV === 'stageprod') {
                return `https://${this.STAGE_PREFIX}.chickasaw.tv/v1`;
            }
                return `https://${this.PROD_PREFIX}.chickasaw.tv/v1`;
        },
        CHROMECAST_RECEIVER_ID: '70563DCB',
        STAGE_PREFIX: 'api-stage',
        PROD_PREFIX: 'api',              
        METATADA_CHANGE_LISTEN_ENDPOINT: 'http://localhost:4042',
        WEBSITE_TITLE: 'Chickasaw.tv',
        APP_ID : '05cb2c1f-7975-4544-992a-142e75cc0db6',
        PANEL_MODES : ['over', 'push', 'slide', 'dock'],
        PANEL_POSITIONS : ['left', 'right', 'top', 'bottom'],
        ROUTE_TRANSLATION_MAP:  ['get', 'details'],
        SEARCH_CATEGORY_LIMIT: 20,
        TWITTER_SITE : "chickasawtv",
        LRU_EXPIRATION: "300000",
        DEFAULT_IMAGE : "/images/CTV-Default.jpg",
        FACEBOOK_APP_ID : "1664097153601121",
        CLIENT_DOMAIN : "https://www.chickasaw.tv",
        FACEBOOK_PAGE_ID : "163581670327923",
        CLIENT_LOGO  : "https://d9lvdmmwvuqi1.cloudfront.net/uploads/production/misc/images/CNTV-embed-gold.png",
        DEFAULT_COORDINATES : {X: 0, Y: 0},
        DEFAULT_SLIDER_INDEX : 0,
        SUPPORTS_PUSH_NOTIFICATIONS : false,
        PUSH_NOTIFICATION_SERVICE_URL : '',
        USE_MOCK_PATTERN: false,
        AUTH_ENABLED: false,
        VIDEO_THUMBNAILS_CHUNK: 1,
        GROUPED_VIDEO_ROWS: false,
        MOBILE_SWIPE_NAVIGATION: false,
        LIST_IMAGE_FALLBACK_COLLECTION: [ 
            "//d9lvdmmwvuqi1.cloudfront.net/uploads/production/misc/images/list-1200xmarquee-generic01.jpg",
            "//d9lvdmmwvuqi1.cloudfront.net/uploads/production/misc/images/list-1200xmarquee-generic010.jpg",
            "//d9lvdmmwvuqi1.cloudfront.net/uploads/production/misc/images/list-1200xmarquee-generic02.jpg",
            "//d9lvdmmwvuqi1.cloudfront.net/uploads/production/misc/images/list-1200xmarquee-generic03.jpg",
            "//d9lvdmmwvuqi1.cloudfront.net/uploads/production/misc/images/list-1200xmarquee-generic04.jpg",
            "//d9lvdmmwvuqi1.cloudfront.net/uploads/production/misc/images/list-1200xmarquee-generic05.jpg",
            "//d9lvdmmwvuqi1.cloudfront.net/uploads/production/misc/images/list-1200xmarquee-generic06.jpg",
            "//d9lvdmmwvuqi1.cloudfront.net/uploads/production/misc/images/list-1200xmarquee-generic07.jpg",
            "//d9lvdmmwvuqi1.cloudfront.net/uploads/production/misc/images/list-1200xmarquee-generic08.jpg",
            "//d9lvdmmwvuqi1.cloudfront.net/uploads/production/misc/images/list-1200xmarquee-generic09.jpg"
        ],
        AUTH_CONFIG: {
            issuer: '',
            clientId: '',
            dummyClientSecret: '',
            scope: 'openid'
        },
        REVERSE_DATA_ROUTES : [
            { routeRoot: 'series', slugCount: 1, obj_type: 'Season' }
        ],
        SHARING_LINKS : {
            facebook: 'https://www.facebook.com/ChickasawTV',
            twitter: 'https://twitter.com/chickasawtv',
            instagram: 'https://instagram.com/chickasawtv',  
            youtube: 'https://www.youtube.com/chickasawtv'          
        },
        ROUTE_ROW_TRIMS : [
            { 
                segments: [ 'playlists', 'videos' ],
                render_types: [ 'playlist' ]
            }
        ],
        CLIENT_ADD_THIS_ID : 'ra-595f929e0839d1de',
        NEXT_PAGE_URL : 'next_page_url',
        SECONDARY_FOOTER_ROUTES : [
            {
                selected: false,
                isInternal: false, //logic will follow here when we encounter first the situation,
                inNewWindow: true, //see above
                text: 'HELP',
                section: 'AUXILIARY',
                path: '/pages/help',
                children : []
            },
            {
                selected: false,
                isInternal: false, //logic will follow here when we encounter first the situation,
                inNewWindow: true, //see above
                text: 'ABOUT&nbsp;US',
                section: 'AUXILIARY',
                path: '/pages/about-us',
                children : []
            },
            {
                selected: false,
                isInternal: false, //logic will follow here when we encounter first the situation,
                inNewWindow: true, //see above
                text: 'TERMS&nbsp;OF&nbsp;USE',
                section: 'AUXILIARY',
                path: '/pages/terms-of-use',
                children : []
            },
            {
                selected: false,
                isInternal: false, //logic will follow here when we encounter first the situation,
                inNewWindow: true, //see above
                text: 'PRIVACY&nbsp;POLICY',
                section: 'AUXILIARY',
                path: '/pages/privacy-policy',
                children : []
            },
            {
                selected: false,
                isInternal: false, //logic will follow here when we encounter first the situation,
                inNewWindow: true, //see above
                text: 'CONTACT&nbsp;US',
                section: 'CONTACT US',
                path: '/contact',
                children : []
            }                    
        ],
        VIDEO_EMBED_SIZE_OPTIONS : [
            { width: "560", height: "315", id: "xs", isDefault: true },
            { width: "640", height: "360", id: "sm" },
            { width: "853", height: "480", id: "md" },
            { width: "1280", height: "720", id: "lg" },
        ],
        VIDEO_EMBED_CODE : '<iframe width="{width}" height="{height}" src="https://www.chickasaw.tv/embed{path}" frameborder="0" allowfullscreen></iframe>',
        VIDEO_COMPLETE_PERCENTAGE : 0.9,
        TWITTERURI: "https://twitter.com/intent/tweet",
        FACEBOOKURI: "https://www.facebook.com/sharer/sharer.php",
        API_HEADERS: {'X-PLATFORM': ''},
        HOME_ROUTE: '/home'  
    }
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/model/app-settings.ts